import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import ReactMarkdown from 'react-markdown'
import { Translation } from '../../contexts/TranslationContext'
import type { ProductDetailResult } from '../../data/ProductFragment'
import { Container } from '../shared/Container'
import { FoundProblemBanner } from '../static/FoundProblemBanner'
import style from './IngredientsTab.module.sass'

type IngredientsTabProps = {
	product: ProductDetailResult
	openModal: () => void
}

export const IngredientsTab: FunctionComponent<IngredientsTabProps> = ({ product, openModal }) => {
	return (
		<Container size="wide" disableGutters variant="leftStickyAligned">
			<div className={style.container}>
				<div className={style.wrapper} id="tab2">
					<div className={style.title}>
						<Translation tr="ingredientsTab.composition.title" />
					</div>
					<div className={clsx(style.value, !product.guaranteedAnalysis && style.italic)}>
						{product.detailedComposition && product.detailedComposition !== '0' ? (
							<ReactMarkdown linkTarget="_blank">{product.detailedComposition}</ReactMarkdown>
						) : (
							<Translation tr="summaryArticle.notSpecified" />
						)}
					</div>
					<div className={style.title}>
						<Translation tr="ingredientsTab.analysis.title" />
					</div>
					<div className={clsx(style.value, !product.guaranteedAnalysis && style.italic)}>
						{product.guaranteedAnalysis && product.guaranteedAnalysis !== '0' ? (
							<span>
								<ReactMarkdown linkTarget="_blank">{product.guaranteedAnalysis}</ReactMarkdown>
							</span>
						) : (
							<Translation tr="summaryArticle.notSpecified" />
						)}
					</div>
					<div className={style.title}>
						<Translation tr="ingredientsTab.metabolizedEnergy.title" />
					</div>
					<div className={clsx(style.value, !product.metabolizedEnergy && style.italic)}>
						{typeof product.metabolizedEnergy === 'number' && product.metabolizedEnergy >= 0 ? (
							<>
								{Math.round(product.metabolizedEnergy)} <Translation tr="ingredientsTab.metabolizedEnergy.unit" />{' '}
							</>
						) : (
							<Translation tr="ingredientsTab.metabolizedEnergy.notSpecified" />
						)}
					</div>
				</div>
				<FoundProblemBanner openModal={openModal} />
			</div>
		</Container>
	)
}
